// The rules behind Account settings -> Sign-in methods (design revision 2026-10-19).
// Cognito never texts a password-reset code to a number that is a sign-in factor,
// and with MFA required people can only change which method is preferred.
import { formatPhone } from '../Sms/smsConsent';

/** Amplify updateMFAPreference input that makes `method` ('sms' | 'totp') the default. */
export function preferenceUpdate(method, enabled = []) {
  if (method === 'sms') {
    return enabled.includes('TOTP') ? { sms: 'PREFERRED', totp: 'NOT_PREFERRED' } : { sms: 'PREFERRED' };
  }
  // The app as default switches texted sign-in codes off, so the number receives
  // password-reset codes instead.
  return enabled.includes('SMS') ? { totp: 'PREFERRED', sms: 'DISABLED' } : { totp: 'PREFERRED' };
}

/** Make `method` the default. If Cognito refuses to switch texts off, keep them on but not preferred. */
export async function setDefaultMethod(method, enabled, updateMFAPreference) {
  try {
    await updateMFAPreference(preferenceUpdate(method, enabled));
  } catch (err) {
    if (method !== 'totp' || !enabled.includes('SMS') || err?.name !== 'InvalidParameterException') throw err;
    await updateMFAPreference({ totp: 'PREFERRED', sms: 'NOT_PREFERRED' });
  }
}

/** Where password-reset codes go, finishing "Password-reset codes are sent ...". */
export function resetDestination({ phone, phoneVerified, enabled = [] }) {
  return phone && phoneVerified && !enabled.includes('SMS')
    ? `by text message to ${formatPhone(phone)}`
    : 'by email';
}
